const messages = {
  required: 'This field is required',
  preventOnlySpaces: 'This field is required',
  validInteger: 'Use only integer numbers',
  validFloat: 'Use only numbers',
  minDate: 'Minimum date reached',
  maxDate: 'Maximum date reached',
  isEmail: 'Incorrect email',
  isPassword:
    'Password must be at least 8 characters long and cannot begin or end with spaces',
  minNumber: (param: number): string =>
    `Please enter a number higher or equal to ${param}`,
  maxNumber: (param: number): string =>
    `Please enter a number lower or equal to ${param}`,
  minLength: (param: number): string =>
    `Please enter the value not shorter than ${param}`,
  default: 'error',
  equalsField: "Passwords don't match",
  containsOnlyEmailsOrUUIDs: 'Invalid email or user',
  containsUUID: 'Not a valid UUID',
  isEmptyArray: '',
  matchRegexp: '',
  maxWords: 'Check phrases. At least one phrase exceeds maximum words.',
};

type ValidationMessageFunction = (param: number) => string;

export type ValidationMessageValue = string | ValidationMessageFunction;

export type ValidationMessages = {
  [name in keyof typeof messages]?: ValidationMessageValue;
};

/**
 * A message looked up by name can be either form, and the function form takes
 * the validation's own parameter.
 */
export const resolveValidationMessage = (
  message: ValidationMessageValue | undefined,
  param?: unknown,
): string | undefined =>
  typeof message === 'function' ? message(Number(param)) : message;

export default messages;
